// Module
var code = " <gh-grid class=\"flex-auto\" theme=\"narrow\" [hasSettings]=\"false\" [ghGridModelData]=\"data\" [definition]=\"gridDefinition\" [useNoRowsOverlay]=\"false\"></gh-grid>";
// Exports
module.exports = code;